import { getGAClientID } from '../../utilities/getGaClientID'
import { getGclid, hasValidGclid } from '../../utilities/getGclid'
import { HubspotIdentifyData } from '../types/hubspotIdentifyData'

export function createIdentifyData(identifyData: HubspotIdentifyData = {}): HubspotIdentifyData {
    // Get client from cookie
    const GAClientID = getGAClientID()
    if (GAClientID) {
        identifyData.ga_client_id = getGAClientID()
    }

    if (hasValidGclid()) {
        identifyData.gclid = getGclid()
    }

    return identifyData
}
